import type { Route } from 'react-resource-router';

import { fg } from '../controllers/feature-gates';

import {
	boysenberryCodePageRoute,
	boysenberryCreateEmbedRoute,
	boysenberryFlowRoute,
	boysenberryRoute,
	homeRoute,
	notFoundRoute,
	settingsCodePlannerRoute,
	settingsCodeReviewerRoute,
} from './routes';

export const createAppRoutes = (
	usersHasAccessToAdminRoutes: boolean,
	userHasRovoEntitlement: boolean,
) => {
	const appRoutes: Route[] = [homeRoute];

	if (
		usersHasAccessToAdminRoutes &&
		userHasRovoEntitlement &&
		fg('code-planner-agent-limited-beta')
	) {
		appRoutes.push(settingsCodePlannerRoute);
	}

	if (usersHasAccessToAdminRoutes && userHasRovoEntitlement) {
		appRoutes.push(settingsCodeReviewerRoute);
	}

	if (fg('dev_agents_boysenberry_route')) {
		appRoutes.push(boysenberryRoute);
		appRoutes.push(boysenberryFlowRoute);
		appRoutes.push(boysenberryCodePageRoute);
		appRoutes.push(boysenberryCreateEmbedRoute);
	}

	// this is a catch all route and should always be the last route
	appRoutes.push(notFoundRoute);

	return appRoutes;
};
